import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Menu } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

const StyledMenuItem = styled(Menu.MenuItem)<{ mode: Theme; disabled?: boolean }>`
  color: ${({ mode }) => sys[mode].text.primary};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

interface MoreOptionsMenuItemProps {
  disabled?: boolean
  StartIcon?: React.ComponentType<{ mode: Theme; color: string }>
  onClick?: () => void
  children: React.ReactNode
  restProps?: Record<string, any>
}

const MoreOptionsMenuItem = ({
  disabled,
  StartIcon,
  onClick,
  children,
  ...restProps
}: MoreOptionsMenuItemProps) => {
  const displayTheme = useDisplayTheme() as Theme
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledMenuItem mode={displayTheme} disabled={disabled} onClick={onClick} {...restProps}>
      <Container>
        {StartIcon && <StartIcon mode={displayTheme} color={sys[displayTheme].text.primary} />}
        {children}
      </Container>
    </StyledMenuItem>
  )
}

export default MoreOptionsMenuItem
